import localDB from "./localDB";

let GLOBAL = require('./globals');

const BranchOfficeData = {
    async tables(search, page) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/branch-office-tables`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async adminTables(search, page) {
        let response = await fetch(`${GLOBAL.BASE_URL}api/branch-office-admin-tables`, {
            method: 'GET',
            headers: {
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async listAdmin() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/branch-offices`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async listAll() {
        const response = await fetch(`${GLOBAL.BASE_URL}api/branch-office-select`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        });
        return await response.json();
    },
    async add(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/branch-offices`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch(() => res(null));
    },
    async delete(id, res) {
        await fetch(`${GLOBAL.BASE_URL}api/branch-offices/${id}`, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            }
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    },
    async update(data, res) {
        await fetch(`${GLOBAL.BASE_URL}api/branch-offices/${data.id}`, {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': localDB.sessionToken()
            },
            body: JSON.stringify(data)
        }).then((response) => response.json()).then((responseData) => res(responseData)).catch((err) => res(null));
    }
};

export default BranchOfficeData;



// WEBPACK FOOTER //
// ./src/data/BranchOfficeData.js